import axios from 'axios';

const API_URL = `${process.env.REACT_APP_API_URL}/api/projets`;

export const fetchProjets = async () => {
  const response = await axios.get(API_URL);
  return response.data;
};

export const fetchProjetById = async (id) => {
  const response = await axios.get(`${API_URL}/${id}`);
  return response.data;
};

export const createProjet = async (projetData) => {
  const response = await axios.post(API_URL, projetData);
  return response.data;
};

export const updateProjet = async (id, projetData) => {
  const response = await axios.put(`${API_URL}/${id}`, projetData);
  return response.data;
};

export const deleteProjet = async (id) => {
  await axios.delete(`${API_URL}/${id}`);
};
